module.exports = __webpack_public_path__ + "img/79664396.406e3fd8.png";